"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObjectEmpty;
function isObjectEmpty(object) {
  return !object || Object.keys(object).length === 0;
}